import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../components/Layout";
import { api } from "../lib/api";
import { Loader2, Plus, Trash2 } from "lucide-react";

export default function OpenSchedule() {
  const nav = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ date: "", open_time: "12:00", close_time: "18:00", note: "" });
  const [saving, setSaving] = useState(false);

  const load = async () => {
    setLoading(true);
    try { const r = await api.get("/admin/open-schedule"); setItems(r.data); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    if (!form.date) return;
    setSaving(true);
    try { await api.post("/admin/open-schedule", form); setForm({ date: "", open_time: "12:00", close_time: "18:00", note: "" }); await load(); }
    finally { setSaving(false); }
  };
  const del = async (id) => { await api.delete(`/admin/open-schedule/${id}`); await load(); };

  return (
    <Layout>
      <div className="max-w-4xl mx-auto px-6 py-10">
        <button onClick={() => nav("/pos/dashboard")} className="label-eyebrow mb-6 inline-block" data-testid="os-back">← Back</button>
        <h1 className="font-display text-4xl font-black mb-3">Open Schedule</h1>
        <p className="text-sm max-w-xl mb-8" style={{ color: "var(--ab-text-muted)" }}>
          List the days you plan to open the popup. Members will get a once-a-week heads-up email roughly 24 hours before the first open day of each week.
        </p>

        <form onSubmit={add} className="surface p-5 flex flex-wrap items-end gap-3 mb-6" data-testid="os-form">
          <div><label className="label-eyebrow block mb-1">Date</label>
            <input type="date" className="input-terminal" value={form.date} onChange={(e) => setForm({...form, date: e.target.value})} required data-testid="os-date" /></div>
          <div><label className="label-eyebrow block mb-1">Open</label>
            <input type="time" className="input-terminal" value={form.open_time} onChange={(e) => setForm({...form, open_time: e.target.value})} data-testid="os-open" /></div>
          <div><label className="label-eyebrow block mb-1">Close</label>
            <input type="time" className="input-terminal" value={form.close_time} onChange={(e) => setForm({...form, close_time: e.target.value})} data-testid="os-close" /></div>
          <div className="flex-1 min-w-[200px]"><label className="label-eyebrow block mb-1">Note (optional)</label>
            <input className="input-terminal" value={form.note} onChange={(e) => setForm({...form, note: e.target.value})} placeholder="e.g. Special event" data-testid="os-note" /></div>
          <button className="btn-primary inline-flex items-center gap-2" disabled={saving} data-testid="os-add">{saving ? <Loader2 size={14} className="animate-spin" /> : <Plus size={14} />} Add Day</button>
        </form>

        {loading ? <Loader2 className="animate-spin" /> : items.length === 0 ? (
          <div className="surface p-6 text-sm" style={{ color: "var(--ab-text-muted)" }} data-testid="os-empty">No open days scheduled.</div>
        ) : (
          <div className="surface divide-y" style={{ borderColor: "var(--ab-border)" }}>
            {items.map((d) => (
              <div key={d.id} className="px-5 py-4 flex items-center gap-3" data-testid={`os-row-${d.id}`}>
                <div className="flex-1">
                  <div className="font-mono font-bold">{d.date}</div>
                  <div className="text-xs" style={{ color: "var(--ab-text-dim)" }}>{d.open_time || "—"} – {d.close_time || "—"}{d.note ? ` · ${d.note}` : ""}</div>
                </div>
                <button onClick={() => del(d.id)} className="btn-danger" style={{ padding: "6px 12px", fontSize: 11 }} data-testid={`os-del-${d.id}`}><Trash2 size={12} /></button>
              </div>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}
